import React from "react";
import { MenuItem } from "@material-ui/core";
import Constant from "./CommonConstants";
import telesalesOpportunityConstants from "./TelesalesOpportunityConstants";
const ownerConstant = {
  userRoleMappingForStatus: {
    [Constant.TSTL]: "TEAM_LEADER",
    [Constant.TSPO]: "PROCESS_MANAGER",
    [Constant.HOM]: "ADMIN",
    [Constant.TSA]: "SALES_AGENT",
    [Constant.adminRole]: "ADMIN",
  },
  reasonMapping: {
    LoginActivity: "Login Activity",
    CallActivity: "Call Activity Logging",
  },
  agentStatusMappingRequired: [
    "Offline",
    "Online",
    "Oncall",
    "Idle",
    "Login Activity",
    "Call Activity Logging",
    telesalesOpportunityConstants.NO_OZONTEL_CALLBACK,
  ],
  liveDataChannelName: "activity",
  liveDataEventName: "activity-event",
  shareLinkEnableEmails: [
    "testingAgentlv@housing.com",
    "ownertestingagent@housing.com",
    "rahul.mallick@housing.com",
  ],
  newActivityLoginAgents: [
    "kamalpandit902756@gmail.com",
    "Ss0865534@gmail.com",
    "mehtaavni930@gmail.com",
    "vikrantsharma4k@gmail.com",
    "Saindeepak958281@gmail.com",
  ],
  shareLinkEnableDynamicProperty: "account.link.share.option.enable",
  getOwnerShareLinkDynamicPpty: (
    { isAdmin, isHousingOwnerAgent },
    getDynamicPropertyByKey
  ) => {
    if (!(isAdmin || isHousingOwnerAgent)) {
      return;
    }
    getDynamicPropertyByKey(ownerConstant.shareLinkEnableDynamicProperty);
  },
  ownerSalesConfigUserEmails: [
    "dealdesk-product@housing.com",
    "dealdesk-tech@housing.com",
    "dealdesk@housing.com",
  ],
  ownerDynamicPropertiesEmail: "pulkit.garg@housing.com",
  additionalOwnerOpportunityStages: [
    {
      name: "LINK_SENT_PAYMENT_FAILED",
      filterName: "PAYMENT_FAILED",
      mystiqueStatusId: 97,
      opportunitySource: "PaymentLink",
    },
  ],
  ownerOpportunityStageObjLastIndex: 7,
  tsaTilesCount: 4,
  tilesCount: 9,
  createOwnerLinkSentFilter: ({
    filters,
    filterName,
    mystiqueStatusId,
    opportunitySource,
    name,
    setFilterParams,
  }) => {
    if (name === "linkSent") {
      filters[name] = name;
    } else if (name === "linkSentPaymentFailed") {
      filters[name] = setFilterParams({
        filterName,
        mystiqueStatusId,
        opportunitySource,
      });
    }
    return filters;
  },
  commercial: {
    ACTIVE_LISTING_STATUS: 2,
    listingApi: () => (process.env.NODE_ENV === "production" ? 26 : 30),
  },
  PG_PROPERTY: 3,
  RESIDENTIAL_PROPERTY: 1,
  RENT_MONEYBACK_PACKAGE_ID: 1749,
  RESALE_MONEYBACK_PACKAGE_ID: 1763,
  RESALE_FIELD_ASSIST_PACKAGE_ID: 1759,
  RENT_FIELD_ASSIST_PACKAGE_ID: 230,
  RENT_ADDON_ADS_BASIC_FIELD_ASSIST_ID: 3354,
  RENT_ADDON_ADS_PREMIUM_FIELD_ASSIST_ID: 3348,
  RENT_ADDON_ADS_PREMIUM_PLUS_FIELD_ASSIST_ID: 3356,
  RENT_ADDON_ASSISTED_FIELD_ASSIST_ID: 3358,
  RENT_ADDON_SUPERASSIST_FIELD_ASSIST_ID: 3360,
  RESALE_ADDON_ADS_BASIC_FIELD_ASSIST_ID: 3355,
  RESALE_ADDON_ADS_PREMIUM_FIELD_ASSIST_ID: 3349,
  RESALE_ADDON_ADS_PREMIUM_PLUS_FIELD_ASSIST_ID: 3357,
  RESALE_ADDON_ASSISTED_FIELD_ASSIST_ID: 3359,
  RESALE_ADDON_SUPERASSIST_FIELD_ASSIST_ID: 3361,
  RENT_ULTRA_ASSIST_WITH_FIELD_ASSIST_ID: 3555,
  RESALE_ULTRA_ASSIST_WITH_FIELD_ASSIST_ID: 3556,
  activeListingsPayload: {
    profileType: "Owner",
    propertyCategoryId: [1, 3],
  },
  destructurePropertiesFromFlatsResponse: ({
    data: { data: { hits: { properties = [] } = {} } = {} } = {},
  }) => properties,
  parseFlatsData: (properties) => {
    return properties.map((property) => {
      const {
        id,
        status,
        flat_slot_details: flatSlotDetails,
        polygons_hash: polygonsHash,
        inventory_configs: inventoryConfigs,
      } = property;

      return {
        id,
        status,
        listing_slot_details: flatSlotDetails,
        paid: !!flatSlotDetails.length,
        polygons_hash: polygonsHash,
        inventory_configs: inventoryConfigs,
      };
    });
  },
  isOwnerProfile: (profileType) => profileType === "Owner",
  isMatchingBuyerAddOn: (packageName) => {
    // Check if a package name matches the MATCHING_BUYER pattern (case-insensitive)
    return /MATCHING_BUYER/i.test(packageName);
  },
  isAddOnPackageByKeyword: (packageName) => {
    // Check if a package name contains add-on keywords (case-insensitive)
    // Used for filtering packages from packageMap before selection
    if (!packageName) return false;

    const addOnKeywords = [
      "MATCHING_BUYER",
      "PHOTOSHOOT",
      "AUDIENCE_MAXIMIZER",
      "BOOST_LISTING",
      "PROPERTY_REPORT",
      "ADDON_ADS_BASIC_FIELD_ASSIST",
      "ADDON_ADS_PREMIUM_PLUS_FIELD_ASSIST",
      "ADDON_ASSISTED_FIELD_ASSIST",
      "ADDON_SUPERASSIST_FIELD_ASSIST",
      "MATCHING_BUYER_ON_DEMAND_20",
      "MATCHING_BUYER_ON_DEMAND_30",
      "MATCHING_BUYER_ON_DEMAND_50",
    ];

    const upperPackageName = packageName.toUpperCase();
    return addOnKeywords.some((keyword) => upperPackageName === keyword);
  },
  isTrialPackageByKeyword: (packageName) => {
    // Used for filtering trial packages from packageMap before selection
    // Trial plans should not be visible to sales on lookup
    if (!packageName) return false;

    const trialKeywords = ["TRIAL_PACKAGE_1", "TRIAL_PACKAGE_2"];

    const upperPackageName = packageName.toUpperCase();
    return trialKeywords.some((keyword) => upperPackageName === keyword);
  },
  isAddOnPackage: (packageName, addOnPackages) => {
    // Check if a package name exists in add-on packages structure
    // Used when addOnPackages data is available from API
    if (!addOnPackages || !packageName) return false;

    const { rent = {}, sell = {} } = addOnPackages;

    // Check in both rent and sell add-on packages
    for (const servicePackages of Object.values(rent)) {
      if (Object.prototype.hasOwnProperty.call(servicePackages, packageName)) {
        return true;
      }
    }

    for (const servicePackages of Object.values(sell)) {
      if (Object.prototype.hasOwnProperty.call(servicePackages, packageName)) {
        return true;
      }
    }

    return false;
  },
  discontinuedOwnerPackages: [
    232, // sell basic
    225, // rent basic
  ],
  ownerPackageDataMap: {
    BASIC: {
      title: "Basic",
    },
    PREMIUM: {
      title: "Premium",
    },
    PREMIUM_PLUS: {
      title: "Premium +",
    },
    ASSISTED: {
      title: "Assist",
    },
    FIELD_ASSIST: {
      title: "Assist +",
    },
    ASSISTED_MONEYBACK: {
      title: "Guarantee",
    },
    TRIAL_PACKAGE_1: {
      title: "Relax",
    },
    TRIAL_PACKAGE_2: {
      title: "Super Relax",
    },
  },
  paidDiscountEntities: {
    TELESALES_UPSELL_PACKAGE_DISCOUNT_OFFER: "upsell",
    TELESALES_RENEW_EXISTING_PACKAGE_DISCOUNT_OFFER: "renew",
  },
  listingFilters: {
    UNPAID: (_, { paid }) => !paid,
    UPSELL_RENEW: ({ ownerPaidDiscountData = {} }, { paid, id }) =>
      !!(paid && ownerPaidDiscountData[id]),
    LIVE_AND_PENDING: (_, { status }) => status === "ACTIVE" || status === "PENDING",
    ALL: (extraData, listing) => {
      const { listingFilters } = ownerConstant;
      return (
        listingFilters.UNPAID(extraData, listing) ||
        listingFilters.UPSELL_RENEW(extraData, listing)
      );
    },
  },
  // gamma ids for upsell and renew are 410 & 412
  upsellCaseReasonId: 415,
  renewCaseReasonId: 417,
  isLocalityIndependentPackage: (packageName = "") => {
    const packages = ["pay-per-lead"];
    return packages.includes(packageName)?.toLowerCase?.() ?? false;
  },
  getListingDropdownOptions: ({
    allListings,
    packageEligibilityData,
    packageId,
  }) => {
    let listingOptions = (allListings || []).filter((listing) => !listing.paid);

    // Filter out unserviceable listings based on package eligibility
    // A listing is considered serviceable if it has at least one eligible package
    if (packageEligibilityData?.listingEligibility) {
      const { listingEligibility } = packageEligibilityData;
      listingOptions = listingOptions.filter((listing) => {
        const listingId = listing.id;
        const packages = listingEligibility[listingId];

        // as discussed with BE do not restrict allocation is data is not available
        if (!packages) {
          return true;
        }

        return (
          packages[packageId]?.isEligible !== false ||
          ownerConstant.isLocalityIndependentPackage(packages[packageId]?.name)
        );
      });
    }

    return listingOptions.map((listing) =>
      typeof listing === "object" ? (
        <MenuItem value={listing} key={listing.id}>
          {listing.id} {"("} {listing.title} {listing.listingCategory}{" "}
          {listing.listingType} {")"}
        </MenuItem>
      ) : (
        <MenuItem value={listing} key={listing}>
          {listing}
        </MenuItem>
      )
    );
  },
  // Package name constants for addOnPackages format
  addOnPackageNames: {
    BOOST_LISTING: "BOOST_LISTING",
    MATCHING_BUYER: "MATCHING_BUYER",
    ASSIGN_RM: "ASSIGN_RM",
    PROPERTY_REPORT: "PROPERTY_REPORT",
    OWNER_SPECIAL_HIGHLIGHTS: "OWNER_SPECIAL_HIGHLIGHTS",
    AUDIENCE_MAXIMIZER: "AUDIENCE_MAXIMIZER",
    PHOTOSHOOT: "PHOTOSHOOT",
  },

  // Package name constants for packagesHistory format
  historyPackageNames: {
    LISTING_BOOST: "Listing Boost",
    MATCHING_BUYER: "Matching Buyer",
    ASSIGN_RM: "Assign RM",
    PDF_DOWNLOAD: "Pdf Download",
    OWNER_SPECIAL_HIGHLIGHTS: "Owner Special Highlights",
    OWNER_AUDIENCE_MAXIMIZER: "Owner Audience Maximizer",
    PHOTOSHOOT: "Photoshoot",
  },

  // Mapping from addOnPackages format to packagesHistory format
  packageNameMapping: {
    BOOST_LISTING: "Listing Boost",
    MATCHING_BUYER: "Matching Buyer",
    ASSIGN_RM: "Assign RM",
    PROPERTY_REPORT: "Pdf Download",
    OWNER_SPECIAL_HIGHLIGHTS: "Owner Special Highlights",
    AUDIENCE_MAXIMIZER: "Owner Audience Maximizer",
    PHOTOSHOOT: "Photoshoot",
  },
  // Only these packages are sold by Housing Assured Agents, and only by them
  HOUSING_ASSURED_PACKAGE_KEY: "HOUSING_ASSURED",
  HOUSING_ASSURED_SERVICES: ["RENT", "SELL"],
};

export default ownerConstant;
